/**
 * Created by HeMengJiao on 2020/03/16.
 */
import config from './config/index'

//配置全局 URL 开发环境 生产环境
let appConfig = {
  API: {
    DOMAIN_NAME: config.DOMAIN_NAME,
    DOMAIN_NAME_v3:config.DOMAIN_NAME_v3,
    WS_BASE_URL: config.WS_BASE_URL,
    API_URL: config.API_URL,
    BASE_URL: config.BASE_URL,
    LOGIN_URL: config.LOGIN_URL,
    REDIRECT_URL: config.REDIRECT_URL,
    BACKSTAGE_URL: config.BACKSTAGE_URL,
    MOBILE_V3: config.MOBILE_V3,
    RECEPTION_URL: config.RECEPTION_URL,
    EXHIBITION_URL: config.EXHIBITION_URL,
    BASE_URL_V3: config.BASE_URL_V3,
    UPLOAD_URL: config.UPLOAD_URL,
  },

  objectStore: {
    BUCKET: config.BUCKET,
    REGION: config.REGION,
    UPLOAD_DOMAIN: config.UPLOAD_DOMAIN,
    ACCESSPATH: config.ACCESSPATH,
  },

  //微信appid
  weChatAppId: config.weChatAppId,

  qiyuesuoUrl: config.qiyuesuo,
  qiyuesuoOfficialWebsiteUrl: config.qiyuesuoOfficialWebsite,

  isDebug: config.isDebug
}
export default appConfig



// WEBPACK FOOTER //
// ./src/appConfig.js